/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './registerServiceWorker'
import Vuetify from 'vuetify'
import mqtt from './plugins/mqtt'
import i18n from '@/plugins/i18n'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
// import 'vuetify/dist/vuetify.min.css'
// import 'vuetify/dist/vuetify.min.css'
import VueSession from 'vue-session'
import VueCharts from 'vue-charts'
import lodash from 'lodash'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueHtml2Canvas from 'vue-html2canvas'
import Toolbar from '@/components/common/Toolbar.vue'
import Card from '@/components/common/Cards.vue'
import CardCheckBox from '@/components/common/CardCheckBox.vue'
import DataTable from '@/components/common/DataTable.vue'
import Tabs from '@/components/common/Tabs.vue'
import Toggle from '@/components/common/ToggleButton.vue'
import CustomToggle from '@/components/common/CustomToggleButton.vue'
import SimpleList from '@/components/common/SimpleList.vue'
import Select from '@/components/common/Select.vue'
import Graph from '@/components/common/Graph.vue'
import GlobalGraph from '@/components/common/GlobalGraph'
import RecyclerDataTable from '@/components/common/RecyclerDataTable.vue'

Vue.use(VueHtml2Canvas)
Vue.use(VueVirtualScroller)
Vue.component('Toolbar', Toolbar)
Vue.component('Card', Card)
Vue.component('CardCheckBox', CardCheckBox)
Vue.component('DataTable', DataTable)
Vue.component('Tabs', Tabs)
Vue.component('Toggle', Toggle)
Vue.component('CustomToggle', CustomToggle)
Vue.component('SimpleList', SimpleList)
Vue.component('Select', Select)
Vue.component('Graph', Graph)
Vue.component('GlobalGraph', GlobalGraph)
Vue.component('RecyclerDataTable', RecyclerDataTable)

Vue.prototype.$bus = new Vue({})

Vue.use(lodash)
var options = {
  persist: true
}
Vue.use(VueSession, options)
Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme: {
    bg: '#04112F',
    primary: '#000427',
    secondary: '#3D485D',
    tertiary: '#34656d',
    fourth: '#34656d',
    fifth: '#151d35',
    // active: '#f4a135',

    accent: '#E9952A',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    green: '#7fff00',
    heat: '#f36615',
    black: '#3c3c3c',
    white: '#fff',
    grey: '#c2c2c2',
    number: '#668cf6',

    activeButton: '#2C3C6F',
    extraPurple: '#6868C9',
    extraYellow: '#ED982B',
    extraBlue: '#00BFA7',
    extraRed: '#FF6B7E',
    extraGreen: '#89DB50',
    extraGrey: '#D4D4D4',

    primaryText: '#FFF',
    secondaryText: '#6b6b6b',
    activeText: '#9fc03b',
    lightText: '#686B71',
    sixth: '#121a37',
    try: '#21E39B'
  },
  options: {
    customProperties: true
  }
})

Vue.use(VueCharts)
Vue.config.productionTip = false
Vue.use(mqtt)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
